export default __webpack_public_path__ + "static/media/3.3be85899.jpg";